import '../style/accordion-BX7v8Y6q.css'
import { defineComponent as _, useCssVars as w, computed as s, openBlock as i, createElementBlock as h, normalizeClass as b, renderSlot as f, unref as t, createElementVNode as v, toRef as k, ref as E, watch as O, withDirectives as M, withKeys as A, withModifiers as D, toDisplayString as R, createBlock as z, normalizeStyle as K } from "vue";
import { ACCORDION_LIST_PROVIDER as I } from "./constant/providers.js";
import { useParentContext as L, useChildContext as N } from "./hooks/useFamily.js";
import P from "./icon.js";
import { ACCORDION_ICON_SIZE as j } from "./constant/accordion.js";
import F from "./directives/ripple.js";
import { useElementId as S } from "./hooks/useElementId.js";
import { useExpansion as H } from "./hooks/useExpansion.js";
import { useFormItem as T } from "./hooks/useFormItem.js";
import { useInputSize as W } from "./hooks/useInputSize.js";
const re = /* @__PURE__ */ _({
  name: "e-accordion",
  __name: "accordion",
  props: {
    allowMultiple: { type: Boolean },
    defaultValue: {},
    gap: { default: 16 }
  },
  setup(c) {
    w((n) => ({
      "21ee8542": r.value
    }));
    const e = c, d = s(() => ["e-accordion", { "e-accordion--compact": e.gap === 0 }]), r = s(() => e.gap + "px"), p = {
      providerKey: I,
      allowMultiple: e.allowMultiple,
      defaultValue: e.defaultValue
    };
    return L(p), (n, u) => (i(), h("div", {
      class: b(d.value),
      role: "tablist",
      "aria-multiselectable": "true"
    }, [
      f(n.$slots, "default")
    ], 2));
  }
}), Z = /* @__PURE__ */ v("div", { class: "horizontal" }, null, -1), q = /* @__PURE__ */ v("div", { class: "vertical" }, null, -1), G = [
  Z,
  q
], J = /* @__PURE__ */ _({
  __name: "plus-minus-toggle",
  props: {
    expanded: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    iconColor: {},
    size: { default: "md" }
  },
  setup(c) {
    w((m) => ({
      "79ecee9d": t(u),
      "01809961": t(p),
      "2db3a203": t(n)
    }));
    const e = c, d = s(() => [
      "e-accordion-toggle",
      `e-accordion-toggle--${e.size}`,
      { "e-accordion-toggle--disabled": e.disabled },
      { "e-accordion-toggle--opened": e.expanded }
    ]), p = {
      sm: "12px",
      md: "14px",
      lg: "16px"
    }[e.size], n = e.iconColor, u = e.size === "sm" ? "1.4px" : "2px";
    return (m, l) => (i(), h("div", {
      class: b(d.value)
    }, G, 2));
  }
}), Q = ["aria-expanded"], U = ["id", "aria-controls", "disabled", "onKeydown"], X = { class: "e-accordion-item-title" }, Y = ["id", "aria-labelledby"], pe = /* @__PURE__ */ _({
  name: "e-accordion-item",
  __name: "accordion-item",
  props: {
    title: { default: "" },
    size: {},
    expanded: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    value: {},
    icon: { default: "chevron-down" },
    iconColor: {},
    withoutStyle: { type: Boolean, default: !1 },
    iconStyle: {},
    ripple: { type: [Boolean, Object], default: !0 },
    detectContentChange: { type: Boolean },
    onExpanded: {},
    onCollapsed: {}
  },
  setup(c) {
    const e = c, { formSize: d } = T(), { actualSize: r, isDefaultSize: p } = W({ formSize: d, propSize: k(e, "size") }), { elementId: n } = S("accordion-item-panel"), { elementId: u } = S("accordion-item-button"), { childValue: m, context: l } = N(
      {
        providerKey: I,
        value: e.value,
        onActiveValueChanged: (o, x) => {
          !x.includes(m) && l?.allowMultiple !== !0 && C(!1);
        }
      }
    ), V = s(() => e.ripple === !0 ? {
      background: "var(--bg-status-primary-subtle)"
    } : e.ripple), $ = s(() => {
      const o = [
        "e-accordion-item",
        {
          "e-accordion-item--expanded": a.value,
          "e-accordion-item--disabled": e.disabled,
          "e-accordion-item--without-style": e.withoutStyle
        }
      ];
      return p.value || o.push(`e-accordion-item--${r.value}`), o;
    }), B = s(() => l ? l.activedValues.includes(m) : e.expanded), y = E(), { expanded: a, setExpanded: C } = H({
      initialValue: B,
      content: y,
      detectContentChange: e.detectContentChange,
      onExpanded: e.onExpanded,
      onCollapsed: e.onCollapsed
    }), g = () => {
      e.disabled || (C(!a.value), l && l.setActiveValue(m));
    };
    return O(() => e.expanded, (o) => C(o)), (o, x) => (i(), h("div", {
      class: b($.value),
      role: "tab",
      "aria-expanded": t(a)
    }, [
      M((i(), h("button", {
        id: t(u),
        class: "e-accordion-item-header",
        "aria-controls": t(n),
        disabled: o.disabled,
        onKeydown: A(D(g, ["stop", "prevent"]), ["space", "enter"]),
        onClick: g
      }, [
        f(o.$slots, "title", { disabled: o.disabled }, () => [
          v("span", X, R(o.title), 1)
        ]),
        f(o.$slots, "icon", { expanded: t(a) }, () => [
          o.icon === "minus-plus" ? (i(), z(J, {
            key: 0,
            "icon-color": o.iconColor,
            rotation: t(a) ? -180 : 0,
            expanded: t(a)
          }, null, 8, ["icon-color", "rotation", "expanded"])) : (i(), z(t(P), {
            key: 1,
            class: "e-accordion-item-icon",
            icon: o.icon,
            color: o.iconColor,
            style: K(o.iconStyle),
            size: t(j)[t(r)],
            rotation: t(a) ? -180 : 0
          }, null, 8, ["icon", "color", "style", "size", "rotation"]))
        ])
      ], 40, U)), [
        [t(F), V.value]
      ]),
      v("div", {
        id: t(n),
        ref_key: "content",
        ref: y,
        class: "e-collapsed-content",
        role: "tabpanel",
        "aria-labelledby": t(u)
      }, [
        f(o.$slots, "default")
      ], 8, Y)
    ], 10, Q));
  }
});
export {
  re as Accordion,
  pe as AccordionItem
};
//# sourceMappingURL=accordion.js.map
